/**
 * Collection Quickview
 */
function collectionQuickview(opts) {
  const config = {
    dom: {
      collection: 'collection',
      heartBtn: 'js-product-heart',
      productCarousel: 'js-product-item-carousel',
      productItem: 'js-pi',
      swatchBtn: 'js-product-swatch',
    },
    cls: {
      hasQuickview: 'has-quickview',
      selected: 'is-selected',
      init: 'is-initialized',
    },
  };

  // Shorthand config
  const c = __.extend(config, opts);

  const uploadedArtwork = localStorage.getItem('uploadedArtwork');
  const hasUploadedArtwork = uploadedArtwork !== null && uploadedArtwork !== '';
  
  let hasQuickview = false;

  // Check if collection element exists and has quickview class
  const $main = document.getElementById(c.dom.collection);
  if ($main) {
    hasQuickview = __.hasClass($main, c.cls.hasQuickview);
  }

  // Enable quickview on any page when there's uploaded artwork
  if (hasUploadedArtwork) {
    hasQuickview = true;
  }

  /**
   * Init
   */
  function init() {
    if (!hasQuickview) return;
    
    // Initial setup for existing product items
    initializeProductItems();
  }

  /**
   * Initialize product items that are currently in the DOM
   */
  function initializeProductItems() {
    const $productItems = document.querySelectorAll(`.${c.dom.productItem}:not(.${c.cls.init})`);
    
    if (!$productItems?.length) {
      // adding a small delay to ensure the Vue components are mounted
      setTimeout(initializeProductItems, 100);
      return;
    }
    
    addEvents($productItems);
  }

  /**
   * Add Events
   */
  function addEvents(productItems) {
    if (!productItems?.length) return;
    
    productItems.forEach(($item) => {
      if (__.hasClass($item, c.cls.init)) return;
      
      __.addClass($item, c.cls.init);
      const quickview = SDG.quickview({
        type: 'single',
        wrapper: $item,
      });

      quickview.init();

      __.addEvent({
        id: $item,
        event: 'click',
        fn: (e) => handleQuickviewOpen(e, quickview, $item),
      });
    });
  }

  /**
   * Handle Quickview Open
   * @param {Object} e - click event
   * @param {Object} quickview instance
   * @param {Element} $item product item
   */
  function handleQuickviewOpen(e, quickview, $item) {
    const { target } = e;
    const $selectedSwatch = $item.querySelector(`.${c.dom.swatchBtn}.${c.cls.selected}`);
    const productColor = $item.getAttribute('data-product-color');
    const selectedColor = $selectedSwatch?.dataset?.color || productColor || null;

    // exclude selectors
    const isCarousel = __.hasClass(target, c.dom.productCarousel)
      || __.parents(target, `.${c.dom.productCarousel}`)?.length;
    const isHeartBtn = __.hasClass(target, c.dom.heartBtn)
      || __.parents(target, `.${c.dom.heartBtn}`)?.length;
    const isSwatchBtn = __.hasClass(target, c.dom.swatchBtn)
      || __.parents(target, `.${c.dom.swatchBtn}`)?.length;

    // check for exclude selectors
    const isExcludeSelector = (
      isCarousel
      || isHeartBtn
      || isSwatchBtn
    );
    if (isExcludeSelector) return;
    // open quickview drawer
    quickview.open(e, selectedColor);
  }

  return init();
}

export default collectionQuickview;
